// ============================================================================
// Temps de vente — buckets serveur + calcul du seuil de repost. Module SÉPARÉ
// du composant graphique : exporter ces fonctions depuis le .tsx cassait le
// Fast Refresh de Vite (rechargement complet de la page à chaque édition).
// ============================================================================

export interface SaleTimeBucket {
  maxHours: number;
  count: number;
}

/** « 24 h » sous 2 jours, « 7 j » au-delà. */
export const formatHoursShort = (hours: number): string =>
  hours < 48 ? `${Math.round(hours)} h` : `${Math.round(hours / 24)} j`;

/**
 * Temps de repost : l'heure à laquelle 80 % des ventes cumulées sont
 * atteintes (interpolation linéaire dans le bucket).
 */
export const computeRepostTimeHours = (buckets: SaleTimeBucket[] | null): number | null => {
  if (!buckets || buckets.length === 0) return null;
  const total = buckets.reduce((sum, b) => sum + b.count, 0);
  if (total === 0) return null;
  const target = total * 0.8;

  let cumulative = 0;
  let lower = 0;
  for (const bucket of buckets) {
    if (cumulative + bucket.count >= target) {
      const ratio = bucket.count === 0 ? 1 : (target - cumulative) / bucket.count;
      return lower + ratio * (bucket.maxHours - lower);
    }
    cumulative += bucket.count;
    lower = bucket.maxHours;
  }
  return buckets[buckets.length - 1].maxHours;
};
